export const APP_STORE_URL =
    'https://apps.apple.com/us/app/fork-ai-nutritionist/id6757946708';

export const PLAY_STORE_URL =
    'https://play.google.com/store/apps/details?id=infiniteloop.tech.mobile';

export const SUPPORT_EMAIL = 'f_uo@infiniteloop-tech.com';
